import React from 'react';
import { Link } from 'react-router-dom';
import { registerClass, currySC, IFNTheme, cns } from '@food/css-manager';
import { oldMediaToGraphqlMedia } from '../utils/data';
import dayjs from 'dayjs';
import { DefaultLayout } from '../utils/layout';

interface IMagazineCardProps {
	className?: any;
	magazine: any;
	layout?: DefaultLayout | string;
}

const styleClass = registerClass(
	(t: IFNTheme) => `

	width: 13vw;
	padding: ${t.ratios.s * t.font.baseSize}px 1vw 0;
	
	&.${sc('layout', DefaultLayout.TABLET)} {
		width: 24vw;
		padding: ${t.ratios.s * t.font.baseSize}px 3vw 0;
	}

	&.${sc('layout', DefaultLayout.MOBILE)} {
		width: 100%;
		padding: ${t.ratios.s * t.font.baseSize}px 1rem 0;

		.${sc('box')} {
			display: inline-block;
		}
	}

	.${sc('box')} {
		width: 100%;
		margin-bottom: ${t.ratios.l * t.font.baseSize}px;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		text-align: center;
		position: relative;

		.${sc('newFlag')} {
			font-size: 80%;
			position: absolute;
			top: 0;
			right: 0;
			border-left: 4em solid transparent;
			border-top: 4em solid ${t.colors.primary.plain};
			transform: translate(0.2em,-0.2em);
			
			span {
				position: absolute;
				top: -2.6em;
				left: -2.6em;
				transform: translateY(-0.3em) rotate(45deg);
				text-transform: uppercase;
				letter-spacing: 0.05em;
				
				font-weight: ${t.font.weights.bold};
				color: ${t.colors.white};
			}
		}

		.${sc('details')} {
			background: ${t.colors.white};
			border-radius: 100%;
			width: 2.2em;
			height: 2.2em;
			position: absolute;
			bottom: 0.4em;
			left: 0.4em;
			display: flex;
			align-content: center;
			justify-content: center;
			align-items: center;

			span,
			&:before,
			&:after {
				content: " ";
				display: inline-block;
				width: 0.35em;
				height: 0.35em;
				border-radius: 100%;
				overflow: hidden;
				background: ${t.colors.grey.plain};
				margin: 0 0.1em;
				opacity: 0.7;
			}
		}
	
		a.${sc('cover')} {
			display: block;
			box-shadow: ${t.boxShadow(1)};
			padding-bottom: 124.25%;
			width: 100%;
			position: relative;
			background: ${t.colors.grey.disabled.light};
			img {
				position: absolute;
				height: 100%;
				width: auto;
				display: block;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}
	
	.${sc('date')} {
		font-weight: ${t.font.weights.bold};
		text-transform: uppercase;
		line-height: 1.2;
		text-align: left;
		font-size: 90%;
		text-align: center;
	}

  `,
);

const sc = currySC(styleClass);

const MagazineCard: React.FC<IMagazineCardProps> = ({ className, magazine, layout }) => {
	const {
		issueNumber,
		featuredImageMedia,
		featuredImageSizes,
		name,
		id,
		customHighlightDays,
		publicationDate,
	} = magazine;
	const media = featuredImageMedia || oldMediaToGraphqlMedia(featuredImageSizes);
	const issue = name + (issueNumber ? ` N.${issueNumber}` : '');
	const url = '/magazine/' + id + '/read';
	const summaryUrl = '/magazine/' + id;
	const publicationDateObj = dayjs(publicationDate);
	const todayObj = dayjs();
	const deltaDays = todayObj.diff(publicationDateObj, 'day');
	const highlightDays = customHighlightDays || magazine.MagazineCollection.highlightDays;
	const isNew = !!(highlightDays && highlightDays >= deltaDays);

	return (
		<div className={cns(styleClass, className, sc('layout-' + layout))}>
			<div className={sc('box')}>
				<Link to={url} className={sc('cover')}>
					{media && <img src={media.mediumThumbUrl} alt={'magazine cover preview'} />}
					{isNew && <div className={sc('newFlag')}><span>{'new'}</span></div>}
				</Link>
				<Link to={summaryUrl} className={sc('details')}><span></span></Link>
			</div>
			<div className={sc('date')}>
				<p><Link to={url}>{issue}</Link></p>
			</div>
		</div>
	);
};
export { MagazineCard };
